import { Link } from 'react-router-dom';
import RegisterLink from '@/components/ui/RegisterLink';

const PAYMENT_LOGOS = [
  { src: 'https://xt30sf.b-cdn.net/media/53b5d40061396a2f2173c.png', alt: 'Visa' },
  { src: 'https://xt30sf.b-cdn.net/media/45897b0061396a8921f26.png', alt: 'Mastercard' },
  { src: 'https://xt30sf.b-cdn.net/media/6c1f142061396b1b1d924.png', alt: 'Google Pay' },
  { src: 'https://xt30sf.b-cdn.net/media/8e7d5410613965b22e34a.png', alt: 'Apple Pay' },
  { src: 'https://xt30sf.b-cdn.net/media/66e97f20613969d994bb9.png', alt: 'Amopay' },
  { src: 'https://xt30sf.b-cdn.net/media/656a0730613969324beeb.png', alt: 'SpeedPay' },
  { src: 'https://xt30sf.b-cdn.net/media/765dcdef5139686d734a5.png', alt: 'OSKO' },
  { src: 'https://xt30sf.b-cdn.net/media/08c834ef51396bb598c3a.png', alt: 'PayID' },
];

const CERT_LOGOS = [
  { src: 'https://xt30sf.b-cdn.net/media/5dad4f30613963c1d6f0e.png', alt: 'PAGCOR' },
  { src: 'https://xt30sf.b-cdn.net/media/1fbd0940613965ecea80d.png', alt: 'BMM Testlabs' },
  { src: 'https://xt30sf.b-cdn.net/media/fec6515061396fbd3c26b.png', alt: 'ThreatMetrix' },
  { src: 'https://xt30sf.b-cdn.net/media/fe74ac50613962679be2c.png', alt: 'TST Verified' },
  { src: 'https://xt30sf.b-cdn.net/media/25b6a86061396e4313830.png', alt: 'SSL Secure' },
  { src: 'https://xt30sf.b-cdn.net/media/51524680613964df823a2.png', alt: 'ThreatMetrix 2' },
  { src: 'https://xt30sf.b-cdn.net/media/5d645e8061396433b427b.png', alt: 'TST Verified 2' },
  { src: 'https://xt30sf.b-cdn.net/media/a5ba559061396903f1413.png', alt: 'SSL Secure 2' },
];

const RESP_LOGOS = [
  { src: 'https://xt30sf.b-cdn.net/media/9129bd90613964d26f392.png', alt: 'eCOGRA' },
  { src: 'https://xt30sf.b-cdn.net/media/540e95a061396b51af2fd.png', alt: 'Gambling Therapy' },
  { src: 'https://xt30sf.b-cdn.net/media/d5d6ada061396fd17de50.png', alt: 'Gambling Help Online' },
  { src: 'https://xt30sf.b-cdn.net/media/f27e25b061396265edc8d.png', alt: '18+ Only' },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden" style={{ background: '#070d14' }}>
      <div className="section-divider absolute top-0 left-0 w-full"></div>

      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, rgba(71,202,241,0.06) 0%, transparent 70%)', filter: 'blur(60px)' }}
      ></div>

      <div className="ribbon ribbon-2"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-5 md:px-8 pt-12 sm:pt-14 pb-10" style={{ paddingBottom: 'max(2.5rem, env(safe-area-inset-bottom, 0px))' }}>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-10 text-center md:text-left" style={{ borderBottom: '1px solid rgba(71,202,241,0.08)' }}>

          {/* Brand */}
          <div className="flex flex-col gap-5 items-center md:items-start">
            <Link to="/">
              <img
                src="https://xt30sf.b-cdn.net/media/21d9c82fb4d9675627365.gif"
                alt="BYBID9"
                className="h-12 w-auto"
                style={{ filter: 'drop-shadow(0 0 12px rgba(71,202,241,0.3))' }}
              />
            </Link>
            <p className="text-[#56626B] text-sm leading-relaxed max-w-xs mx-auto md:mx-0">
              Premier Exclusive Online Entertainment In Asia. Australia&apos;s legit casino with fast payouts. Exclusive Monthly Deposit Ranking AUD 3,999, Daily Easy Step AUD 100, min deposit AUD 10.
            </p>
          </div>

          {/* Navigation (matches bybid9.com footer) */}
          <div className="flex flex-col items-center md:items-stretch">
            <h4 className="text-white font-bold text-sm mb-5 tracking-widest uppercase" style={{ color: '#47CAF1' }}>Navigation</h4>
            <nav className="flex flex-col gap-3 items-center md:items-start w-full max-w-sm mx-auto md:max-w-none md:mx-0">
              {[
                { label: 'About Bybid9', href: 'https://bybid9.tips/RFLANDINGPAGESEO' },
                { label: 'Online Pokies Australia', href: 'https://bybid9.tips/RFLANDINGPAGESEO' },
                { label: 'Slot Strategy', href: 'https://bybid9.tips/RFLANDINGPAGESEO' },
                { label: 'Review Center', href: 'https://bybid9.tips/RFLANDINGPAGESEO' },
              ].map((item) => (
                <RegisterLink
                  key={item.label}
                  section="footer_navigation"
                  linkLabel={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#56626B] hover:text-[#47CAF1] text-sm transition-colors flex items-center gap-2 group justify-center md:justify-start"
                >
                  <i className="ri-arrow-right-s-line text-[#47CAF1] opacity-0 group-hover:opacity-100 transition-opacity hidden md:inline"></i>
                  {item.label}
                </RegisterLink>
              ))}
            </nav>
          </div>

          {/* Legal links (matches bybid9.com) */}
          <div className="flex flex-col items-center md:items-stretch">
            <h4 className="text-sm mb-5 tracking-widest uppercase font-bold" style={{ color: '#47CAF1' }}>Legal</h4>
            <nav className="flex flex-col gap-3 mb-6 md:mb-8 items-center md:items-start w-full max-w-sm mx-auto md:max-w-none md:mx-0">
              {[
                { label: 'Terms & Conditions', href: 'https://bybid9.tips/RFLANDINGPAGESEO' },
                { label: 'Privacy Policy', href: 'https://bybid9.tips/RFLANDINGPAGESEO' },
                { label: 'Responsible Gambling', href: 'https://bybid9.tips/RFLANDINGPAGESEO' },
                { label: 'FAQ Support', href: 'https://bybid9.tips/RFLANDINGPAGESEO' },
              ].map((item) => (
                <RegisterLink
                  key={item.label}
                  section="footer_legal"
                  linkLabel={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#56626B] hover:text-[#47CAF1] text-sm transition-colors flex items-center gap-2 group justify-center md:justify-start"
                >
                  <i className="ri-arrow-right-s-line text-[#47CAF1] opacity-0 group-hover:opacity-100 transition-opacity hidden md:inline"></i>
                  {item.label}
                </RegisterLink>
              ))}
            </nav>
            <RegisterLink
              section="footer"
              linkLabel="Register Now"
              href="https://bybid9.tips/RFLANDINGPAGESEO"
              className="btn-premium text-sm px-7 py-3.5 min-h-[48px] w-full max-w-sm md:max-w-none md:w-auto inline-flex items-center justify-center mx-auto md:mx-0"
            >
              <span>Register Now</span>
            </RegisterLink>
          </div>
        </div>

        {/* Payment logos */}
        <div className="py-8" style={{ borderBottom: '1px solid rgba(71,202,241,0.06)' }}>
          <p className="text-[#56626B] text-xs text-center mb-5 tracking-widest uppercase">Available Payment Methods</p>
          <div className="flex flex-wrap justify-center gap-3">
            {PAYMENT_LOGOS.map((logo) => (
              <div
                key={logo.alt}
                className="rounded-xl px-4 py-2 flex items-center justify-center transition-all duration-300 hover:scale-105"
                style={{ background: 'rgba(71,202,241,0.04)', border: '1px solid rgba(71,202,241,0.1)' }}
              >
                <img src={logo.src} alt={logo.alt} className="max-h-6 max-w-full object-contain opacity-60 hover:opacity-90 transition-opacity" />
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6">
          <p className="text-[#56626B] text-xs text-center sm:text-left">
            © 2026 Bybid9 | All Rights Reserved. | 18+ Only | Gamble Responsibly
          </p>
          <p className="text-[#56626B]/40 text-xs text-center">
            Bybid9 | Premier Exclusive Online Entertainment Platform in Asia.
          </p>
        </div>
      </div>
    </footer>
  );
}
